import React from 'react'
import { connect } from 'react-redux'
import { fetchEOYTop10IfNeeded } from '~/features/actions'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import unescape from 'lodash/unescape'

class EOYTop10 extends React.Component {

  componentDidMount(){
    const { match, history, dispatch } = this.props
    dispatch(fetchEOYTop10IfNeeded())
  }

  render() {
    const { EOYTop10 } = this.props
    var settings = {
      dots: false,
      slidesToShow: 1,
      centerMode: true,
      infinite: true,
      speed: 0,
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            autoplay: true,
            slidesToShow: 1,
            arrows: false
          }
        },
        {
          breakpoint: 1440,
          settings: {
            autoplay: true,
            slidesToShow: 1,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            autoplay: true,
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    }
    const bnas = EOYTop10.items.map((item, index) => {
      return (
        <div className="list-wrapper" key={index}>
          <div className="cover"><img src={item.field_image[0].url} alt={item.field_image[0].alt} /></div>
          <div className="list"><h3>{unescape(item.title[0].value)}</h3>
          <div dangerouslySetInnerHTML={{__html: item.body[0].value}}></div></div>
        </div>
      )
    })
    return (
      <div id="eoy-top-10">
        <h2 className="margin">The Chris Cobcroft 2024 Top Tens <img id="cc-button" src="/assets/CCTOP10_SCHTAMP-01.svg" /></h2>
        
        <Slider {...settings}>
          {bnas}
        </Slider>
        <div className="margin" style={{paddingTop: '2em'}}><Link to="/zed-announcers-top-tens">Check out more Top Tens from 4ZZZ contributors</Link></div>
      </div>
    )

  }

}

export default connect( state => ({ EOYTop10: state.EOYTop10 })) (EOYTop10)
